import { ArrowRight, BookOpenCheck, LockKeyhole } from "lucide-react";
import { course } from "../content/course";

type LandingProps = {
  onStart: () => void;
  hasSavedProgress: boolean;
};

export function Landing({ onStart, hasSavedProgress }: LandingProps) {
  return (
    <main id="main-content">
      <section className="hero">
        <img
          className="hero-image"
          src="/assets/ai-learning-journey.webp"
          alt=""
        />
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="brand-lockup">
            <img src="/assets/wcar-logo.svg" alt="WirelessCar" />
            <span className="brand-mark">WCar · AI DAY · 2026 · VW Delivery</span>
          </div>
          <p className="hero-kicker">90 minute workshop preparation</p>
          <h1>{course.title}</h1>
          <p className="hero-subtitle">{course.subtitle}</p>
          <div className="hero-meta">
            <span>
              <LockKeyhole size={16} /> Private by design
            </span>
            <span>English</span>
            <span>Self-paced</span>
          </div>
        </div>
      </section>

      <section className="route-section" aria-labelledby="route-heading">
        <div className="section-intro">
          <p className="eyebrow">One foundation. One workshop.</p>
          <h2 id="route-heading">Everyone starts from the same baseline before AI Day.</h2>
        </div>
        <div className="route-grid">
          {[
            ["LLM basics", "Understand how LLMs generate responses and why fluent output is not proof of truth."],
            ["LLM risks", "Recognize hallucinations, prompt injection, data leakage, and the need for human accountability."],
            ["Using AI as a work tool", "Frame tasks, iterate, verify results, and turn useful work into reusable patterns."],
            ["Workshop vocabulary", "Understand models, tools, agents, skills, MCP, harnesses, and working loops."],
            ["What exists already", "Find approved repositories, skills, Codex guidance, and examples from VW Delivery."],
          ].map(([title, description], index) => {
            return (
              <article className="route-card" key={title}>
                <span className="route-icon">
                  <BookOpenCheck size={25} />
                </span>
                <span className="route-label">Step {index + 1}</span>
                <strong>{title}</strong>
                <span className="route-description">{description}</span>
              </article>
            );
          })}
        </div>
        <button className="primary-button landing-cta" type="button" onClick={onStart}>
          {hasSavedProgress ? "Continue the crash course" : "Start the crash course"} <ArrowRight size={17} />
        </button>
      </section>
    </main>
  );
}
